export default {
	invalidProps: '最小日期不能大於最大日期',
	invalidDate: '無效的日期格式',
	tooEarly: '所選日期不能小於最大日期',
	tooLate: '所選日期不能大於最大日期'
};
